var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"vacatures-deputatie"},_vm._l((_vm.items.slice().splice(0, 5)),function(childItem){return _c('li',{key:childItem.itemID},[(!_vm.packages)?_c('router-link',{attrs:{"to":{
        path: `/catalogus/${_vm.parentCategorySlug}/${_vm.categorySlug}/artikel/${childItem.Slug}`
      }}},[_vm._v(_vm._s(childItem.Description))]):_c('router-link',{attrs:{"to":{
        path: `/pakketten/artikel/${childItem.Slug}`
      }}},[_vm._v(_vm._s(childItem.Description))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }